import React from "react";
import "../../index.css";

const Road = ({ roadImage, carImage, carPosition}) => {
    const blocks = 7;
    const blockHeight = 100 / blocks;

  return (
    <div
    className="relative place-items-center h-full w-full">
        <div style={{borderRadius: "12px"}} className="grid grid-rows-7 w-[52px] h-fit overflow-hidden">
        {Array.from({ length: blocks }).map((_, index) => (
            <div key={index} className="w-fit h-full">
            <img
                src={roadImage}
                alt={`Road segment ${index + 1}`}
                className="w-[52px] h-[149px] object-cover"
            />
            </div>
        ))}
        </div>
        <img
            src={carImage}
            alt="Car"
            className="absolute w-[38px] h-[92px] transition-all duration-500"
            style={{
                top: `${blockHeight * carPosition + blockHeight / 2}%`,
                left: "50%",
                transform: "translate(-50%, -50%)",
            }}
        />
    </div>
  );
};

export default Road;